<app-header></app-header>
<section class="container-xxl">
  <div class="breadcrumb-area">
    <nav aria-label="breadcrumb mb-0">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a class="screen-reader" [attr.title]="language=='English'?'Home':'होम'" routerLink="/">{{'Home'|translate}}</a></li>
        <li class="breadcrumb-item"><a class="screen-reader" [attr.title]="language=='English'?'News':'समाचार'" routerLink="/newslist">{{'News'| translate}}</a></li>
        <li class="breadcrumb-item active screen-reader">{{ "NewsDetails" | translate}}</li>
      </ol>
    </nav>
  </div>
  <div class="inner-page-sidedetails">
    <div id="section-New"></div>
    <div class="inner-banner-image">
      <div class="image-area">
        <img class="screen-reader" src="assets/images/inner-banner-2.webp" alt="inner-banner-image">
      </div>
    </div>
    <div class="details">
      <div class="title">
        <h2 class="screen-reader">{{'News' | translate}}</h2>
      </div>
      <div class="description">
        <div class="news mb-3">
          <div class="row">
            <div class="col-lg-12">
              <div class="info-box">
                <div class="news-section">

                  <!-- left section -->

                  <div class="card h-100">
                    <div class="card-body">
                      <div class="row">
                        <div class="col-xxl-8 col-xl-8 col-lg-8 col-md-12" *ngIf="media.length > 0">
                          <div class="news-full-sec">
                            <h2 class="screen-reader"> {{htmldecode(language == 'English' ? media[0].title: media[0].titleInHindi)}}
                            </h2>
                            <div class="list-inline-item d-flex mb-3 mt-2 custom-border-bottom pb-3">
                              <div class="stip-num screen-reader font-adjust"> <span><i
                                    class="bi bi-calendar3 me-1"></i>{{media[0].publishDate|date}} </span> </div>
                            </div>

                            <ng-container *ngIf="media[0].uploadImage != ''">
                              <div class="news-photo">
                                <img [src]="this.imageUrl + media[0].uploadImage" class="img-fluid" alt="FCI-News-Image">
                              </div>
                            </ng-container>
                            <p class="screen-reader font-adjust " innerHtml="{{htmldecode(language == 'English' ? media[0].description: media[0].descriptionInHindi)}}"></p>
                          </div>
                          <div class="fp_footer" *ngIf="media[0].uploadDocument != ''">
                            <div class="mt-3">
                              <ul class="pdf-news">
                                <li>
                                  <a target="_blank" [href]="this.imageUrl+media[0].uploadDocument" class="screen-reader font-adjust"
                                    title="The pdf file Open in New Window">
                                    {{htmldecode(language == 'English' ? media[0].title: media[0].titleInHindi)}}
                                  </a>
                                  <div class="opening-date font-adjust" *ngIf="checkFileExists(media[0])">
                                    <a target="_blank" [href]="this.imageUrl+media[0].uploadDocument"
                                    [attr.title]="language=='English'?'Download PDF':'डाउनलोड पीडीऍफ़'" class="text-success screen-reader"><span class="me-2"> <i
                                          class="bi bi-download me-1"></i> Download
                                        ({{media[0].uploadDocument_details.fileSize }} <span style="text-transform: uppercase;" *ngIf="checkFileType(media[0])!==false" [innerHtml]="checkFileType(media[0]).file"></span>
                                        {{media[0].dtmCreatedOn | date:'MMM d, y'}}) </span></a>
                                    <span class="labels text-muted screen-reader"></span>
                                  </div>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>


                        <!-- left section -->


                        <!-- right section -->
                        <div class="col-xxl-4 col-xl-4 col-lg-4 col-md-12 custom-border-start">
                          <div class="d-flex custom-border-bottom align-items-center justify-content-between">
                            <div class="flex-grow-1 hed-news">
                              <h5 class="screen-reader"> {{'LatestNews' | translate}} </h5>
                            </div>
                            <div class="news-list-icon"><i class="bi bi-newspaper fs-4 "></i></div>
                          </div>
                          <div class="mt-3 news-scroll">
                            <div *ngFor="let item of mediaResponse" class="section-content custom-border-bottom  px-2 py-2"
                              [class.bg-active]="checkIs(item.id,processId)">
                              <div class="row">
                                <div class="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-4 col-5"  *ngIf="item.uploadImage">
                                  <div class="news-image-area">
                                    <img class="img-fluid" [src]="this.imageUrl+item.uploadImage"
                                      alt="news-image-thumb">
                                  </div>
                                </div>
                                <div class="col-xxl-8 col-xl-8 col-lg-8 col-md-8 col-sm-8 col-7">
                                  <div class="news-description-area py-2">
                                    <div class="date-area">
                                      <p><span class="text-muted screen-reader"><i class="bi bi-calendar me-1"></i>
                                          {{item.publishDate|date:'dd-MM-yyyy'}}</span>
                                      </p>
                                    </div>
                                    <div class="heading-area">
                                      <div [ngSwitch]="checkIs(item.id,processId)">
                                        <div *ngSwitchCase="true">
                                          <a class="screen-reader font-adjust" [attr.title]="language=='English'?'Go to News Details':'समाचार विवरण पर जाएँ'" (click)="viewDetails(item.id)" routerLinkActive="router-link-active"
                                            style="color: #f0890e;">{{htmldecode(language == 'English' ? item.title: item.titleInHindi)}}</a>
                                        </div>
                                        <div *ngSwitchCase="false">
                                          <a class="screen-reader font-adjust" [attr.title]="language=='English'?'Go to News Details':'समाचार विवरण पर जाएँ'" (click)="viewDetails(item.id)"
                                            routerLinkActive="router-link-active">{{htmldecode(language == 'English' ? item.title: item.titleInHindi)}}</a>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- right section -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<app-clients></app-clients>

<app-footer></app-footer>